import { render, staticRenderFns } from "./LayoutDefault.vue?vue&type=template&id=380c0cf8&scoped=true&"
import script from "./LayoutDefault.vue?vue&type=script&lang=js&"
export * from "./LayoutDefault.vue?vue&type=script&lang=js&"
import style0 from "./LayoutDefault.vue?vue&type=style&index=0&id=380c0cf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c0cf8",
  null
  
)

component.options.__file = "LayoutDefault.vue"
export default component.exports